import { onMounted, onUnmounted, ref } from 'vue';

export const useToggleModal = () => {
    const input = ref(null);
    const isOpen = ref(false);
    const axis = ref({ x: 0, y: 0 });

    const updatePosition = () => {
        if (input.value) {
            const rect = input.value.getBoundingClientRect();
            axis.value = {
                x: rect.left + window.scrollX,
                y: rect.top + window.scrollY,
            };
        }
    };

    const toggleModal = () => {
        isOpen.value = !isOpen.value;

        if (isOpen.value) {
            updatePosition();
        }
    };

    onMounted(() => {
        window.addEventListener('resize', updatePosition);
    });

    onUnmounted(() => {
        window.removeEventListener('resize', updatePosition);
    });

    return {
        input,
        isOpen,
        axis,
        updatePosition,
        toggleModal,
    };
};
